// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    // Use a no-op lock instead of the default Web Locks API (navigatorLock).
    // Safari (desktop & iOS) aggressively steals locks when many components
    // request the session concurrently, causing "Lock was stolen by another
    // request" errors that cascade into failed Edge Function calls.
    lock: async <Result>(_name: string, _acquireTimeout: number, fn: () => Promise<Result>) => {
      return await fn();
    },
  }
});